// import React, { useState, useEffect } from 'react';
// import './patient.css';
// import { Grid, TextField, Button, MenuItem, Typography, Checkbox } from '@mui/material';
// import { formatPhoneNumber } from '../../components/formatPhone';
// import { FaTimes } from 'react-icons/fa'
// import { useSelector, useDispatch } from 'react-redux';
// import moment from 'moment';
// import * as patientActions from '../../core/Store/Actions/PatientActions';

// const AddChildren = (props) => {
//     const { onCloseModal } = props;
//     const dispatch = useDispatch();
//     const userData = useSelector(state => state.registerReducer.userVerifyData);
//     const fhir_patient_id = userData.user?.person?.fhir_patient_id || '';
//     const providerData = useSelector(
//         state => state.patientReducer.validateUser,
//     );
//     const access_token = providerData.access_token;
//     const patientDetails = useSelector(state => state.patientReducer.patientDetails);
//     const { telecom, address } = patientDetails || {};
//     console.log("Patient Details", patientDetails);

//     const genderList = [{
//         "name": "Male",
//         "value": "male"
//     },
//     {
//         "name": "Female",
//         "value": "female"
//     }];
//     const [firstName, setFirstName] = useState('');
//     const [lastName, setLastName] = useState('');
//     const [email, setEmail] = useState('');
//     const [dob, setDob] = useState('');
//     const [gender, setGender] = useState('');
//     const [phone, setPhone] = useState();
//     const [street, setStreet] = useState(
//         (address && address[0]?.line?.[0]) || '',
//     );

//     const [city, setCity] = useState(address && address[0].city);
//     const [state, setState] = useState(address && address[0].state);
//     const [postalCode, setPostalCode] = useState(
//         address && address[0].postalCode,
//     );

//     useEffect(() => {
//         if (patientDetails) {
//             setEmail(
//                 telecom && ((telecom[1] && telecom[1].system === 'email' && telecom[1].value) || (telecom[0] && telecom[0].system === 'email' && telecom[0].value)) ||
//                 'N/A',
//             );
//             setPhone(
//                 (telecom && telecom[0] && telecom[0].use === 'mobile' && telecom[0].value) ||
//                 'N/A',
//             );
//         }
//     }, [patientDetails]);
//     const addChildAPI = () => {
//         const params = new FormData();
//         params.append('patientId', providerData.id);
//         params.append('mobileNo', phone);
//         params.append('email', email);
//         params.append('address1', street);
//         params.append('city', city);
//         params.append('state', state);
//         params.append('zip', postalCode);
//         params.append('firstName', firstName);
//         params.append('lastName', lastName);
//         params.append('birthday', moment(dob).toLocaleString());
//         params.append('gender', gender.toLowerCase());
//         params.append('count', 0);
//         dispatch(patientActions.addChildren(params, access_token));
//     };
//     const handleSubmit = e => {
//         e.preventDefault();
//         console.log("Handle Submit");
//         addChildAPI();
//     };

//     return (
//         <div className='addChildModal'>
//             <FaTimes style={{ height: '50px', textAlign: 'end', position: 'absolute', right: 20, cursor: 'pointer' }} onClick={() => onCloseModal()} />
//             <div className="subFormModal">
//                 <Typography style={{ textAlign: 'center', fontSize: 24, fontWeight: "bold" }}>Add Child</Typography>
//                 <form onSubmit={handleSubmit}>
//                     <Grid>
//                         <TextField
//                             label="First Name"
//                             variant='standard'
//                             required
//                             value={firstName}
//                             onChange={e => setFirstName(e.target.value)}
//                             style={{ width: '100%', marginRight: 10 }}
//                         // onSubmit={()=>{
//                         //     validateUser()
//                         // }}
//                         />
//                         <TextField
//                             label="Last Name"
//                             variant='standard'
//                             required
//                             value={lastName}
//                             onChange={e => setLastName(e.target.value)}
//                             style={{ width: '100%' }}
//                         />
//                     </Grid>
//                     <Grid style={{ marginTop: 10 }}>
//                         <TextField
//                             label="DOB"
//                             variant='standard'
//                             required
//                             value={dob}
//                             //inputProps={{ max: getAdultDate() }}
//                             type='date'
//                             onChange={e => setDob(e.target.value)}
//                             style={{ width: '100%', marginRight: 10 }}
//                             InputLabelProps={{ shrink: true }}
//                         />
//                         <TextField
//                             label="Gender"
//                             variant='standard'
//                             required
//                             select
//                             value={gender}
//                             onChange={e => setGender(e.target.value)}
//                             style={{ width: '100%' }}
//                         >
//                             {genderList.map(({ value, name }) => (
//                                 <MenuItem value={value} key={value}>
//                                     {name}
//                                 </MenuItem>
//                             ))}
//                         </TextField>
//                     </Grid>
//                     <Grid style={{ width: '100%', justifyContent: 'space-between', marginTop: 10 }}>
//                         <TextField
//                             label="Email"
//                             variant='standard'
//                             type="email"
//                             required
//                             value={email}
//                             onChange={e => setEmail(e.target.value)}
//                             style={{ width: '100%', marginRight: 10 }}
//                             disabled={true}
//                         />
//                         <TextField
//                             label="Phone"
//                             variant='standard'
//                             type="phone"
//                             required
//                             value={phone}
//                             onChange={e => { formatPhoneNumber(e.target.value, setPhone) }}
//                             style={{ width: '100%' }}
//                             disabled={true}
//                             InputLabelProps={{ shrink: true }}
//                         />
//                     </Grid>
//                     <Grid style={{ marginTop: 20, textAlign: 'center' }} >
//                         <Button type="submit" variant="contained" color="primary">
//                             Register
//                         </Button>
//                     </Grid>
//                 </form>
//             </div>
//         </div>
//     )
// }

// export default AddChildren
import React, { useState, useEffect } from 'react';
import './patient.css';
import { Grid, TextField, Button, MenuItem, Typography, Checkbox } from '@mui/material';
import { formatPhoneNumber } from '../../components/formatPhone';
import { FaTimes } from 'react-icons/fa'
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import * as patientActions from '../../core/Store/Actions/PatientActions';

const AddChildren = (props) => {
    const { onCloseModal } = props;
    const dispatch = useDispatch();
    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const fhir_patient_id = userData.user?.person?.fhir_patient_id || '';
    const providerData = useSelector(
        state => state.patientReducer.validateUser,
    );
    const loading = useSelector(state => state.patientReducer.loading);
    const access_token = providerData.access_token;
    const patientDetails = useSelector(state => state.patientReducer.patientDetails);
    const { telecom, address } = patientDetails || {};

    const genderList = [{
        "name": "Male",
        "value": "male"
    },
    {
        "name": "Female",
        "value": "female"
    }];
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [dob, setDob] = useState('');
    const [gender, setGender] = useState('');
    const [phone, setPhone] = useState();
    const [street, setStreet] = useState(
        (address && address[0]?.line?.[0]) || '',
    );

    const [city, setCity] = useState(address && address[0].city);
    const [state, setState] = useState(address && address[0].state);
    const [postalCode, setPostalCode] = useState(
        address && address[0].postalCode,
    );

    useEffect(() => {
        if (patientDetails) {
            setEmail(
                telecom && ((telecom[1] && telecom[1].system === 'email' && telecom[1].value) || (telecom[0] && telecom[0].system === 'email' && telecom[0].value)) ||
                'N/A',
            );
            setPhone(
                (telecom && telecom[0] && telecom[0].use === 'mobile' && telecom[0].value) ||
                'N/A',
            );
        }
    }, [patientDetails]);
    const addChildAPI = () => {
        const params = new FormData();
        params.append('patientId', providerData.id);
        params.append('mobileNo', phone);
        params.append('email', email);
        params.append('address1', street);
        params.append('city', city);
        params.append('state', state);
        params.append('zip', postalCode);
        params.append('firstName', firstName);
        params.append('lastName', lastName);
        params.append('birthday', moment(dob).toLocaleString());
        params.append('gender', gender.toLowerCase());
        params.append('count', 0);
        // params.append(
        //     "body",
        //     new Blob(
        //       [
        //         JSON.stringify({
        //            patientId: providerData.id,
        //            mobileNo: phone,
        //            email: email,
        //            address1: street,
        //            city: city,
        //            state: state,
        //            zip: postalCode,
        //            firstName: firstName,
        //            lastName: lastName,
        //            birthday: moment(dob).toLocaleString(),
        //            gender: gender.toLowerCase(),
        //            count: 0
        //         }),
        //       ],
        //       { type: "application/json" }
        //     )
        //   );
        dispatch(patientActions.addChildren(params, access_token));
    };
    const handleSubmit = e => {
        e.preventDefault();
        addChildAPI();
    };

    return (
        <div className='addChildModal'>
            <FaTimes style={{ height: '7%', color: "#FFFFFF", textAlign: 'end', position: 'absolute', right: 20, cursor: 'pointer' }} onClick={() => onCloseModal()} />
            <div className="paperModel">
                <Typography style={{
                    textAlign: "left",
                    fontFamily: 'Manrope',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: 28,
                    display: "flex",
                }} component="h1" className="paperModelh1" variant="h5">
                    Add a Child
                </Typography>
                <div className="paperModelContent">
                    <form className="form" onSubmit={handleSubmit}>
                        <Grid container spacing={2} >
                            <Grid item xs={12}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="firstname"
                                    label="First Name"
                                    name="firstname"
                                    autoComplete="firstname"
                                    variant="standard"
                                    value={firstName}
                                    style={{fontFamily: 'Manrope'}}
                                    onChange={e => setFirstName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="lastname"
                                    label="Last Name"
                                    name="lastname"
                                    autoComplete="lastname"
                                    variant="standard"
                                    value={lastName}
                                    style={{fontFamily: 'Manrope'}}
                                    onChange={e => setLastName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="phonenumber"
                                    label="Phone Number"
                                    name="phonenumber"
                                    autoComplete="phonenumber"
                                    variant="standard"
                                    disabled={true}
                                    value={phone}
                                    style={{fontFamily: 'Manrope'}}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={e => { formatPhoneNumber(e.target.value, setPhone) }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="emailaddress"
                                    label="Email Address"
                                    name="emailaddress"
                                    autoComplete="emailaddress"
                                    variant="standard"
                                    value={email}
                                    style={{fontFamily: 'Manrope'}}
                                    onChange={e => setEmail(e.target.value)}
                                    disabled={true}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Date Of Birth"
                                    margin="normal"
                                    required
                                    fullWidth
                                    type="date"
                                    id="dateofbirth"
                                    name="dateofbirth"
                                    autoComplete="dateofbirth"
                                    variant="standard"
                                    style={{fontFamily: 'Manrope'}}
                                    onChange={e => setDob(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Gender"
                                    variant='standard'
                                    required
                                    select
                                    value={gender}
                                    onChange={e => setGender(e.target.value)}
                                    style={{ width: '100%',fontFamily:'manrope' }}
                                >
                                    {genderList.map(({ value, name }) => (
                                        <MenuItem value={value} key={value}>
                                            {name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            {/* <Grid item xs={6}>
                                <TextField

                                    margin="normal"
                                    required
                                    fullWidth
                                    id="streetname"
                                    label="Street Name"
                                    name="streetname"
                                    autoComplete="streetname"
                                    variant="standard"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField

                                    margin="normal"
                                    required
                                    fullWidth
                                    id="lastname"
                                    label="City"
                                    name="cityname"
                                    autoComplete="cityname"
                                    variant="standard"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField

                                    margin="normal"
                                    required
                                    fullWidth
                                    id="statename"
                                    label="State"
                                    name="statename"
                                    autoComplete="statename"
                                    variant="standard"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="zipcode"
                                    label="Zipcode"
                                    name="zipcode"
                                    autoComplete="zipcode"
                                    variant="standard"
                                />
                            </Grid> */}
                            <Grid style={{ justifyContent: 'center' }} container item xs={12}>
                                <Grid item>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        className="ButtonSubmitDanger"
                                        onClick={() => onCloseModal()}
                                        disabled={loading}
                                        style={{ marginRight: '10%',fontFamily:'manrope' }}
                                    >
                                        Close
                                </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        className="ButtonSubmit"
                                        disabled={loading}
                                        style={{fontFamily:'manrope' }}
                                    >
                                        Next
                                </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddChildren
